import {api} from '@services/Api'

interface GenerateResponse {
  access_token: string,
  token_type: string,
}

export const accessTokenApi = api.injectEndpoints({
  endpoints: (build) => ({
    generateToken: build.mutation<GenerateResponse, void>({
      query: () => `profile/generate_token`,
    }),
    deleteToken: build.mutation<Boolean, void>({
      query: () => ({
        url: `profile/delete_clz_token`,
        method: 'POST',
      }),
    }),
  })
});

export const { useGenerateTokenMutation, useDeleteTokenMutation } = accessTokenApi;
